import type { SorterResult } from "antd/lib/table/interface";
import { type FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import type { CardTypeList } from "src/app/features/CardType/types/CardTypeList";
import { type ExtendedColumnsType, GenericTable, type ResourceTableProps } from "../../../../../components";
import {
    displayDateTimeValue,
    displayEnumValue,
    displayStatusValue,
} from "../../../../../components/Table/components/PropertyTable/transformations/cellTransformations";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../core/router/types/routerTypes";

export const CardTypesTable: FC<ResourceTableProps<CardTypeList>> = ({ onStateChanged, onRowSelectionChange, datasource, resource }) => {
    const { t } = useTranslation();
    const getColumnsConfig = useCallback(
        (sortInfo: SorterResult<CardTypeList>): ExtendedColumnsType<CardTypeList>[] => {
            return [
                {
                    title: t("cardType.id"),
                    key: "id",
                    dataIndex: "id",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "id" ? sortInfo.order : null,
                },
                {
                    title: t("cardType.name"),
                    key: "name",
                    dataIndex: "name",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "name" ? sortInfo.order : null,
                },
                {
                    title: t("cardType.cardType"),
                    key: "cardType",
                    dataIndex: "cardType",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "cardType" ? sortInfo.order : null,
                    render: (value) => displayEnumValue(value, "application-profile-type-enum"),
                },
                {
                    title: t("cardType.status"),
                    key: "status",
                    dataIndex: "status",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "status" ? sortInfo.order : null,
                    render: (value) => displayStatusValue(value),
                },
                {
                    title: t("cardType.changed"),
                    dataIndex: "changed",
                    key: "changed",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "changed" ? sortInfo.order : null,
                    render: (value) => displayDateTimeValue(value),
                },
            ];
        },
        [t],
    );

    const navigate = useNavigate();
    const onRowClick = (record: CardTypeList) => navigate(`${BASE_PATH}/${ResourceName.CARD_TYPES}/${FORM_ACTION.EDIT}/${record.id}`);

    return (
        (datasource && (
            <GenericTable<CardTypeList>
                getColumnsConfig={getColumnsConfig}
                datasource={datasource}
                name="cardTypes_table"
                onSelectionCallback={onRowSelectionChange}
                onStateChanged={onStateChanged}
                onRow={(record: CardTypeList) => {
                    return {
                        onClick: () => onRowClick(record),
                    };
                }}
                resource={resource}
            />
        )) ||
        null
    );
};
